import { ACTIONS } from '../Constants';
import {
    canCalculateCompleteness,
    completePathwayContent,
    computeUserLearningAssetCompleteness,
    unlockAndCompleteContent
} from '../utils/UserLearningAssetUtils';
import { VerbFetch } from '../VerbFetch';
import { cachedGenerateSectionItemById, getUserLearningAsset } from './UserLearningAssets';

export const updateSection = (value) => (dispatch) => {
    dispatch({
        type: ACTIONS.UPDATE_SECTION,
        payload: value
    });

    return value;
};

export const updateWorkspaceAsset = (userLearningAsset) => (dispatch) => {
    dispatch({
        type: ACTIONS.UPDATE_WORKSPACE_ASSET,
        payload: userLearningAsset
    });

    return userLearningAsset;
};

export const updateWorkspaceCompletedSectionItems = (completedSectionItem) => (dispatch) => {
    dispatch({
        type: ACTIONS.UPDATE_WORKSPACE_ASSET_COMPLETED_SECTIONITEMS,
        payload: completedSectionItem
    });

    return completedSectionItem;
};

export const setWorkspaceActiveSlideNumber = (slideNumber) => (dispatch) => {
    dispatch({
        type: ACTIONS.SET_WORKSPACE_ACTIVE_SLIDE_NUMBER,
        payload: slideNumber
    });

    return slideNumber;
};

export const clearWorkspaceAsset = () => (dispatch) => {
    dispatch({
        type: ACTIONS.CLEAR_WORKSPACE_ASSET
    });
};

export const putWorkspaceAsset = (userLearningAsset) => (dispatch) => {
    dispatch({
        type: ACTIONS.PUT_WORKSPACE_ASSET,
        payload: userLearningAsset
    });

    return userLearningAsset;
};

export const _putWorkspaceAssetOnFinal = (params) => {
    const { userLearningAssetId, body, pathsContext } = params;

    // scrub activity from PUT request since its a readonly property
    delete body.track;

    return VerbFetch(`${pathsContext.serverUrl}/userlearningassets/${userLearningAssetId}/final`, {
        method: 'PUT',
        body
    });
};

export const putWorkspaceAssetOnFinal = (params) => {
    const { userLearningAssetId, body, secondTry = false, pathsContext } = params;
    return (dispatch, getState) => {
        dispatch({
            type: ACTIONS.PUT_WORKSPACE_ASSET_ON_FINAL
        });

        return _putWorkspaceAssetOnFinal(params)
            .then((body) => {
                const { userLearningAsset } = body;

                if (userLearningAsset.track) {
                    userLearningAsset.track.sectionItemById = cachedGenerateSectionItemById(userLearningAsset.track);
                }

                if (canCalculateCompleteness(userLearningAsset)) {
                    userLearningAsset.completeness = computeUserLearningAssetCompleteness(userLearningAsset);
                }

                dispatch({
                    type: ACTIONS.PUT_USERLEARNINGASSET_SUCCESS,
                    payload: {
                        userLearningAsset
                    }
                });

                if (userLearningAsset.isCompleted) {
                    const store = getState();
                    const { userCollections, userPathways } = store;
                    const completedData = unlockAndCompleteContent(
                        userLearningAsset._id,
                        Object.values(userCollections.byId)
                    );

                    const completedCollections = completedData.userCollections;
                    const { completedCollectionIds } = completedData;
                    if (completedCollections.length) {
                        dispatch({
                            type: ACTIONS.PREDICT_COMPLETED_USERCOLLECTIONS,
                            payload: {
                                userCollections: completedCollections
                            }
                        });
                    }
                    if (completedCollectionIds.length) {
                        const { completedPathways, currentPathwayCompletedNow } = completePathwayContent(
                            completedCollectionIds,
                            Object.values(userPathways.byId)
                        );
                        dispatch({
                            type: ACTIONS.PREDICT_COMPLETED_USERPATHWAYS,
                            payload: {
                                userPathways: completedPathways
                            }
                        });
                        body.currentPathwayCompletedNow = currentPathwayCompletedNow;
                        body.completedPathways = completedPathways;
                    }
                }

                return body;
            })
            .catch((err) => {
                if (err.status === 409 && !secondTry) {
                    return dispatch(getUserLearningAsset({ userLearningAssetId, pathsContext })).then(
                        (updatedUserLearningAsset) => {
                            delete body.revision;
                            const newBodyToSend = {
                                ...updatedUserLearningAsset,
                                ...body
                            };

                            dispatch({
                                type: ACTIONS.PUT_WORKSPACE_ASSET_ON_FINAL
                            });

                            return _putWorkspaceAssetOnFinal({
                                userLearningAssetId,
                                body: newBodyToSend,
                                secondTry: true,
                                pathsContext
                            });
                        }
                    );
                }
                console.error(err);
                return null;
            });
    };
};
